import { DynamicBannerSkeleton } from './variants/BannerSkeleton/BannerSkeleton.async'
import { DynamicFilterCatalogSkeleton } from './variants/FilterCatalogSkeleton/FilterCatalogSkeleton.async'
import { DynamicItemLoader } from './variants/ItemLoader/ItemLoader.async'
import { DynamicOrderItemSkeleton } from './variants/OrderItemSkeleton/OrderItemSkeleton.async'
import { DynamicPersonalDataSkeleton } from './variants/PersonalDataSkeleton/PersonalDataSkeleton.async'
import { DynamicPersonalOrderSkeleton } from './variants/PersonalOrderSkeleton/PersonalOrderSkeleton.async'
import { DynamicServiceSkeleton } from './variants/ServiceSkeleton/ServiceSkeleton.async'
import { DynamicSidebarMobileSkeleton } from './variants/SidebarMobileSkeleton/SidebarMobileSkeleton.async'
import { DynamicTradeInCategoriesSkeleton } from './variants/TradeInCategoriesSkeleton/TradeInCategoriesSkeleton.async'
import { DynamicTradeInDeviceSkeleton } from './variants/TradeInDeviceSkeleton/TradeInDeviceSkeleton.async'

import { DynamicGiftProductSkeleton } from '@/shared/ui/Skeletons/variants/GiftProductSkeleton/GiftProductSkeleton.async'
import { DynamicTradeInProductDeviceSkeleton } from '@/shared/ui/Skeletons/variants/TradeInProductDeviceSkeleton/TradeInProductDeviceSkeleton.async'

type SkeletonProps = {
	type: SkeletonType
}

export enum SkeletonType {
	MainCard = `MainCard`,
	Order = `Order`,
	PersonalData = `PersonalData`,
	PersonalOrder = `PersonalOrder`,
	SidebarMobile = `SidebarMobile`,
	TradeInCategories = `TradeInCategories`,
	TradeInDevice = `TradeInDevice`,
	FilterCatalog = `FilterCatalog`,
	Banner = `Banner`,
	Service = `Service`,
	GiftProduct = `GiftProduct`,
	TradeInDeviceProduct = `TradeInDeviceProduct`
}

const SkeletonMap: Record<SkeletonType, () => JSX.Element> = {
	[SkeletonType.MainCard]: () => <DynamicItemLoader />,
	[SkeletonType.Order]: () => <DynamicOrderItemSkeleton />,
	[SkeletonType.PersonalData]: () => <DynamicPersonalDataSkeleton />,
	[SkeletonType.PersonalOrder]: () => <DynamicPersonalOrderSkeleton />,
	[SkeletonType.SidebarMobile]: () => <DynamicSidebarMobileSkeleton />,
	[SkeletonType.TradeInCategories]: () => <DynamicTradeInCategoriesSkeleton />,
	[SkeletonType.TradeInDeviceProduct]: () => <DynamicTradeInProductDeviceSkeleton />,
	[SkeletonType.TradeInDevice]: () => <DynamicTradeInDeviceSkeleton />,
	[SkeletonType.FilterCatalog]: () => <DynamicFilterCatalogSkeleton />,
	[SkeletonType.Banner]: () => <DynamicBannerSkeleton />,
	[SkeletonType.Service]: () => <DynamicServiceSkeleton />,
	[SkeletonType.GiftProduct]: () => <DynamicGiftProductSkeleton />
}

export const Skeletons = ({ type }: SkeletonProps): JSX.Element => SkeletonMap[type]()
